import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

// http://playable.dev.com:8067/?doc=gmaker/api%2fgmaker%2ftemplate.go#-gmaker-template-check

export function fetchGmakerTemplateList(params) {
  return request({
    url: `${v2Host}/gmaker/template/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function checkGmakerTemplate(data) {
  return request({
    url: `${v2Host}/gmaker/template/check`,
    method: 'post',
    data,
  })
}

export function createGmakerTemplate(data) {
  return request({
    url: `${v2Host}/gmaker/template/create`,
    method: 'post',
    data,
  })
}

export function createProjectGmakerTemplate(data) {
  return request({
    url: `${v2Host}/gmaker/template/create-project`,
    method: 'post',
    data,
  })
}

export function updateGmakerTemplate(data) {
  return request({
    url: `${v2Host}/gmaker/template/update`,
    method: 'post',
    data,
  })
}

export function deleteGmakerTemplate(data) {
  return request({
    url: `${v2Host}/gmaker/template/delete`,
    method: 'post',
    data: data,
  })
}

/**
 * getGmakerTemplateInfo
 * @param {{template_id: number, skin_id: number, skin_id: number}} params
 */
export function getGmakerTemplateInfo(params) {
  return request({
    url: `${v2Host}/gmaker/template/info`,
    method: 'get',
    params,
  })
}

/**
 * getGmakerTemplateOriginalInfo 获取初始化 json 数据
 * @param {{id: string|number, type: number, skin_id: number}} params
 */
export function getGmakerTemplateOriginalInfo(params) {
  return request({
    url: `${v2Host}/gmaker/template/init-json`,
    method: 'get',
    params,
  })
}

/**
 * preview 预览模板
 * @param {{id: string|number, lang: string, skin_id: number}} params
 */
export function previewGmakerTemplate(params, config) {
  return request({
    url: `${v2Host}/gmaker/template/preview`,
    method: 'get',
    params,
    ...config,
  })
}

export function saveGmakerTemplate(params, data, withoutError) {
  return request({
    url: `${v2Host}/gmaker/template/save`,
    method: 'post',
    data,
    params,
    withoutError: withoutError,
  })
}

/**
 * resetGmakerTemplate
 * @param template_id {number}
 * @param all {number} 1 重置所有内容，2 重置 json
 * @param skin_id {number} 皮肤 id
 * @returns {AxiosPromise}
 */
export function resetGmakerTemplate({ template_id, all, skin_id }) {
  return request({
    url: `${v2Host}/gmaker/template/reset`,
    method: 'post',
    params: {
      template_id,
      all,
      skin_id,
    },
  })
}

/**
 * getGmakerBasicTplInfo 检查动态参数模板预览
 * @param tpl_id 模板 id
 * @param basic_id 基础包 id
 * @returns {*}
 */
export function getGmakerBasicTplInfo({ tpl_id, basic_id }) {
  return request({
    url: `${v2Host}/gmaker/template/basic-tpl-info`,
    method: 'get',
    params: {
      tpl_id,
      basic_id,
    },
  })
}

export function activateGmakerTemplate({ id }) {
  return request({
    url: `${v2Host}/gmaker/template/activate?id=${id}`,
    method: 'post',
  })
}

/**
 * 设置模型 更新分类property
 * @param {id:number,skeleton_type:number} data
 */
export function updateGmakerTemplateProperties(data) {
  return request({
    url: `${v2Host}/gmaker/template/update-category-properties`,
    method: 'post',
    data,
  })
}
